import axios from 'axios';
import {fetchConfig} from '../util/util';

const HOST_URL = fetchConfig('hostUrl');

const getBusinessSummary = async () => {
  return (await axios.get(`${HOST_URL}/pen-health`)).data;
};

const getFlags = async (businessId) => {
  return (await axios.get(`${HOST_URL}/pen-health/flags`, {params: {business_id: businessId}})).data;
};

export default {getBusinessSummary, getFlags};
